export default __webpack_public_path__ + "static/media/Res_Amazon-Route-53-Hosted-Zone_48_Light.efc8b024.svg";